import { useTranslation } from 'react-i18next';
import { ChaptersStatus } from 'api';
import BasePurchaseDialog, { PurchaseSummaryLine } from '../BasePurchaseDialog';

export type PurchaseDialogProps = {
  open: boolean;
  onClose: () => void;
  handleConfirmPurchase: () => void;
  chapterSummaries: PurchaseSummaryLine[];
  purchaseChapters: ChaptersStatus[];
  unitBalance: number;
  isPurchaseLoading: boolean;
};

const PurchaseDialog = ({
  open,
  onClose,
  handleConfirmPurchase,
  chapterSummaries,
  unitBalance,
  purchaseChapters,
  isPurchaseLoading,
}: PurchaseDialogProps) => {
  const { t } = useTranslation();

  return (
    <BasePurchaseDialog
      open={open}
      onClose={onClose}
      onSubmit={handleConfirmPurchase}
      disabled={isPurchaseLoading}
      chapterSummaries={chapterSummaries}
      purchaseChapters={purchaseChapters}
      unitBalance={unitBalance}
      primaryButtonText={t(
        'ui.event-management.events.purchase-profiles.purchase-title',
      )}
      secondaryButtonText={t('ui.event-management.cancel')}
      title={t('ui.event-management.events.purchase-profiles.purchase-title')}
      variant="default"
    />
  );
};

export default PurchaseDialog;
